// eslint-disable-next-line import/prefer-default-export
export function formatReadingTime(time, formatTo = "mins") {
  // assuming time is always in sec
  if (!time) throw new Error("time is required.")
  if (formatTo === "mins") {
    return Math.ceil((time / 60).toFixed(2))
  }
  if (formatTo === "hours") {
    return (time / (60 * 60)).toFixed(2)
  }
  return time
}
